import script from "./CandidateDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateDetails.vue?vue&type=script&setup=true&lang=js"

import "./CandidateDetails.vue?vue&type=style&index=0&id=402191ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402191ec"]])

export default __exports__